<ng-container *ngLet="loadingData$ | async as loading">
  <app-loader *ngIf="loading"></app-loader>
  <ng-container *ngIf="!loading">
    <div class="header" *ngLet="breakPointObserve$ | async">
      <button [disabled]="isNotPublicCatalog" class="btn-empty" (click)="copyLinks()" [matTooltip]="'OTHER.COPY_LINK' | translate">
        <app-hoverable-svg
          [ngClass]="{ 'element-disabled': isNotPublicCatalog }"
          [icon]="icons.Links"
          class="svg24 dark-gray-color"
        ></app-hoverable-svg>
      </button>
      <button
        *ngIf="hasGeo"
        class="btn-empty"
        (click)="showMap = !showMap"
        [matTooltip]="(showMap ? 'OTHER.HIDE_MAP' : 'OTHER.SHOW_MAP') | translate"
      >
        <app-hoverable-svg [icon]="showMap ? icons.LocationCrossed : icons.Location" class="svg24 dark-gray-color"></app-hoverable-svg>
      </button>

      <div style="display: flex" class="btn-empty" [ngClass]="{ 'element-disabled': isNotPublicCatalog }">
        <a
          *ngIf="!isDynamic && !isArchiveCatalog"
          [routerLink]="incorrectDataPage"
          [queryParams]="incorrectDataPageParams"
          [matTooltip]="'DATA.SHARED.MORE_VERT_MENU.REPORT_INCORRECT_DATA' | translate"
        >
          <app-hoverable-svg
            [ngClass]="{ 'element-disabled': isNotPublicCatalog }"
            [icon]="icons.Feedback"
            class="svg24 dark-gray-color"
          ></app-hoverable-svg>
        </a>
      </div>

      <button class="btn-empty back-to-object" *ngIf="isMap" (click)="backISelectedItem.emit()" [matTooltip]="'OTHER.SHOW_MAP' | translate">
        <app-hoverable-svg [icon]="icons.BackToObject" class="svg24 dark-gray-color"></app-hoverable-svg>
      </button>

      <button class="btn-empty" (click)="closeItemCard()">
        <app-hoverable-svg [icon]="icons.Close" class="svg24 dark-gray-color"></app-hoverable-svg>
      </button>
    </div>
    <div *ngIf="showMap" class="map">
      <app-map [onePoint]="true" [pointIcon]="'/assets/svg/location.svg'" [pointIconSize]="[34, 34]" [mapGeoData]="mapGeoData"> </app-map>
    </div>
    <div *ngLet="itemFields$ | async as fields" [ngStyle]="{ height: !showMap ? 'calc(100% - 50px)' : 'calc(60% - 50px)' }">
      <app-catalog-item-card-info
        [showAllFields]="false"
        [itemFields]="itemFields$ | async"
        [itemData]="itemData$ | async"
        (close)="closeItemCard()"
      ></app-catalog-item-card-info>
    </div>
  </ng-container>
</ng-container>
